import React, { useContext, useState } from "react";
import { Modal, Input, Button, Tabs, Form } from "antd";
import GoogleOutlined from "@ant-design/icons/GoogleOutlined";
import { FaFacebookF } from "react-icons/fa";
import styled from "styled-components";
import { connect } from "react-redux";
import ActionCreator from "../ActionCreator";
import { Link, navigate } from "gatsby";
import * as Constants from "../constants";
import * as Cart from "../Contexts/CartContext";
import { Context } from "../AppContext";
import { ErrLogin, errorHandler } from "../errors";
import { Text } from "../Widgets";
import * as Theme from "../Theme";

const UISTATE = {
  normal: "normal",
  enterprise: "enterprise",
};

const items = [
  {
    label: "一般會員",
    key: UISTATE.normal,
  },
  {
    label: "企業會員",
    key: UISTATE.enterprise,
  },
];

function LoginModal({ appActions }) {
  const [uiState, setUiState] = useState(UISTATE.normal);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const app = useContext(Context);
  const open = app.state.openLoginModal;

  const handleTabsChange = (e) => {
    setUiState(e);
  };

  const [form] = Form.useForm();

  const login = async (values) => {
    const { email, password, gui_number } = values;

    setLoading(true);

    let payload = {
      username: email,
      password,
    };

    if (uiState === UISTATE.enterprise) {
      payload = { ...payload, gui_number };
    }

    try {
      const resp = await app.actions.login(payload);
      // TODO: deprecated
      await appActions.login({
        ...payload,
        setToken: app.actions.setToken,
      });
      Cart.Actions.fetchCart();

      app.actions.setLoginModal(false);
      const enableBind = resp?.bind;
      if (enableBind) {
        navigate(`/profile?login=email`);
      }
    } catch (ex) {
      if (ex.error === "user_type_error") {
        ex = new ErrLogin("此帳號非此會員類型，請選擇正確的類型");
      } else {
        setError(true);
      }
      console.error(ex);
      errorHandler(ex, "登入失敗");
    }
    setLoading(false);
  };

  return (
    <StyledModal
      open={open}
      onCancel={() => app.actions.setLoginModal(false)}
      footer={null}
      width="1122px"
      destroyOnClose={true}
      closeIcon={
        typeof window !== "undefined" &&
        window.innerWidth > Theme.breakpoints.lg
          ? null
          : true
      }
    >
      <Wrapper>
        <LogoSection>
          <StyledImg src="/images/login-logo.png" alt="login-logo" />

          <StyledText size="xs" weight="400">
            Sensations Print®
          </StyledText>
        </LogoSection>
        <FormSection>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Text
              size="xl"
              weight="700"
              style={{ lineHeight: "42px", letterSpacing: -0.56 }}
            >
              登入
            </Text>
            <Text
              size="sm"
              color="#949699"
              weight="400"
              style={{ marginLeft: "auto" }}
            >
              還不是會員嗎？
            </Text>
            <Link
              to="/register"
              onClick={() => {
                app.actions.setEnterpriseRegister(
                  uiState === UISTATE.enterprise ? true : false
                );
              }}
            >
              <Text size="sm" color="#232324" weight="700">
                立即註冊
              </Text>
            </Link>
          </div>
          {/* {error && (
            <Alert
              message="登入失敗"
              description="請重新確認您的信箱與密碼，然後再試一次"
              type="error"
              showIcon
              style={{ marginBottom: 10 }}
            />
          )} */}

          <div>
            <div style={{ display: "flex" }}>
              <Tabs
                defaultActiveKey={UISTATE.normal}
                items={items}
                onChange={handleTabsChange}
                style={{ width: "100%" }}
              />
            </div>

            {uiState === UISTATE.normal ? (
              <Form form={form} name={UISTATE.normal} onFinish={login}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "stretch",
                    flexDirection: "column",
                  }}
                >
                  <Text size="xs" weight="500" color="#949699">
                    電子郵件
                  </Text>
                  <Form.Item
                    name="email"
                    rules={[
                      { required: true, message: "信箱必填" },
                      {
                        type: "email",
                        message: "電子郵件格式有誤，請重新輸入",
                      },
                    ]}
                    validateTrigger="onBlur"
                  >
                    <StyledInput
                      id="login-username-input"
                      placeholder="請輸入信箱"
                      variant="underlined"
                    />
                  </Form.Item>

                  <div
                    style={{
                      position: "relative",
                    }}
                  >
                    <Text size="xs" weight="500" color="#949699">
                      密碼
                    </Text>
                    <Form.Item
                      name="password"
                      rules={[{ required: true, message: "密碼必填" }]}
                    >
                      <StyledInput
                        id="login-password-input"
                        placeholder="請輸入密碼"
                        type="password"
                        variant="underlined"
                      />
                    </Form.Item>
                    {error && (
                      <Text
                        size="xs"
                        weight="500"
                        style={{
                          color: "#FF6026",
                          position: "absolute",
                          left: 0,
                          bottom: "3px",
                        }}
                      >
                        帳號密碼有誤，請重新檢查後再次輸入
                      </Text>
                    )}
                    <Link
                      to="/fgpass"
                      style={{
                        color: "#FF6026",
                        marginLeft: "auto",
                        position: "absolute",
                        right: 0,
                        bottom: "3px",
                      }}
                      onClick={() => app.actions.setLoginModal(false)}
                    >
                      忘記密碼？
                    </Link>
                  </div>
                </div>

                <Form.Item>
                  <StyledSubmitButton
                    type="primary"
                    htmlType="button"
                    onClick={() => form.submit()}
                    loading={loading}
                  >
                    登入
                  </StyledSubmitButton>
                </Form.Item>
              </Form>
            ) : (
              <Form form={form} name={UISTATE.enterprise} onFinish={login}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "stretch",
                    flexDirection: "column",
                  }}
                >
                  <Text size="xs" weight="500" color="#949699">
                    公司統編
                  </Text>
                  <Form.Item
                    name="gui_number"
                    rules={[{ required: true, message: "統編必填" }]}
                  >
                    <StyledInput
                      id="login-gui_number-input"
                      placeholder="請輸入統編"
                      variant="underlined"
                    />
                  </Form.Item>

                  <Text size="xs" weight="500" color="#949699">
                    電子郵件
                  </Text>
                  <Form.Item
                    name="email"
                    rules={[
                      { required: true, message: "信箱必填" },
                      {
                        type: "email",
                        message: "電子郵件格式有誤，請重新輸入",
                      },
                    ]}
                    validateTrigger="onBlur"
                  >
                    <StyledInput
                      id="login-username-input"
                      placeholder="請輸入信箱"
                      variant="underlined"
                    />
                  </Form.Item>

                  <div
                    style={{
                      position: "relative",
                    }}
                  >
                    <Text size="xs" weight="500" color="#949699">
                      密碼
                    </Text>
                    <Form.Item
                      name="password"
                      rules={[{ required: true, message: "密碼必填" }]}
                    >
                      <StyledInput
                        id="login-password-input"
                        placeholder="請輸入密碼"
                        type="password"
                        variant="underlined"
                      />
                    </Form.Item>
                    {error && (
                      <Text
                        size="xs"
                        weight="500"
                        style={{
                          color: "#FF6026",
                          position: "absolute",
                          left: 0,
                          bottom: "3px",
                        }}
                      >
                        帳號密碼有誤，請重新檢查後再次輸入
                      </Text>
                    )}
                    <Link
                      to="/fgpass"
                      style={{
                        fontSize: 14,
                        color: "#FF6026",
                        marginLeft: "auto",
                        position: "absolute",
                        right: 0,
                        bottom: "3px",
                      }}
                      onClick={() => app.actions.setLoginModal(false)}
                    >
                      忘記密碼？
                    </Link>
                  </div>
                </div>

                <Form.Item>
                  <StyledSubmitButton
                    type="primary"
                    htmlType="button"
                    onClick={() => form.submit()}
                    loading={loading}
                  >
                    登入
                  </StyledSubmitButton>
                </Form.Item>
              </Form>
            )}
          </div>

          <div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{ flex: 1, height: 1, backgroundColor: "darkgray" }}
              ></div>
              <div style={{ margin: 10, fontSize: 16 }}>
                或使用以下帳號快速登入
              </div>
              <div
                style={{ flex: 1, height: 1, backgroundColor: "darkgray" }}
              ></div>
            </div>

            <SocialSignInGroup>
              <StyledSocialButton
                icon={<FaFacebookF style={{ fontSize: 24 }} />}
                href={`${Constants.apiUrl}/auth/facebook`}
              >
                Facebook
              </StyledSocialButton>

              <StyledSocialButton
                icon={<GoogleOutlined style={{ fontSize: 24 }} />}
                href={`${Constants.apiUrl}/auth/google`}
              >
                Google
              </StyledSocialButton>
            </SocialSignInGroup>
          </div>
        </FormSection>
      </Wrapper>
    </StyledModal>
  );
}

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 16px;
    overflow: hidden;
  }

  .ant-tabs-nav {
    margin-bottom: 20px;
  }

  .ant-tabs-tab {
    color: #949699;

    &.ant-tabs-tab-active .ant-tabs-tab-btn {
      color: #232324;
    }

    + .ant-tabs-tab {
      margin-left: 24px;
    }
  }

  [class^="ant-tabs"] {
    font-size: 16px;
  }

  .ant-tabs-ink-bar {
    background: #ff6026;
    height: 1px !important;
  }

  .ant-modal-close {
    background: #232324;
    color: #fff;
    top: 0;
    right: 0;
    border-radius: 0;
    width: 56px;
    height: 56px;

    & [class*=" ant-modal"] {
      font-size: 16px;
    }
  }

  @media screen and (max-width: ${Theme.breakpoints.lg}px) {
    margin: 0 !important;
    max-width: 100% !important;
    top: 0;
    padding-bottom: 0;

    .ant-modal-content {
      border-radius: 0;
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  height: 651px;

  @media screen and (max-width: ${Theme.breakpoints.lg}px) {
    flex-direction: column;
    height: auto;
  }
`;

const LogoSection = styled.div`
  background: #f2f2f2;
  display: flex;
  width: 50%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;

  @media screen and (max-width: ${Theme.breakpoints.lg}px) {
    width: 100%;
    padding: 20px 0;
    height: 480px;
  }

  @media screen and (max-width: ${Theme.breakpoints.xs}px) {
    height: 320px;
  }
`;

const StyledImg = styled.img`
  max-width: 410px;
  max-height: 320px;
  width: 100%;

  @media screen and (max-width: ${Theme.breakpoints.lg}px) {
    max-width: 500px;
    max-height: 390px;
  }

  @media screen and (max-width: ${Theme.breakpoints.xs}px) {
    max-width: 250px;
    max-height: 190px;
  }
`;

const StyledText = styled(Text)`
  line-height: 20px;
  letter-spacing: -0.014em;
  position: absolute;
  bottom: 32px;

  @media screen and (max-width: ${Theme.breakpoints.lg}px) {
    bottom: 20px;
  }
`;

const FormSection = styled.div`
  width: 50%;
  padding: 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media screen and (max-width: ${Theme.breakpoints.lg}px) {
    width: 100%;
    min-height: calc(100dvh - 480px);
  }

  @media screen and (max-width: ${Theme.breakpoints.xs}px) {
    min-height: calc(100dvh - 320px);
  }
`;

const StyledInput = styled(Input)`
  font-size: 16px;
`;

const StyledSubmitButton = styled(Button)`
  background: #000000;
  border-radius: 10px;
  width: 100%;
  font-size: 16px;
  font-weight: 700;
  height: 48px;
`;

const StyledSocialButton = styled(Button)`
  border-radius: 12px;
  height: 48px;
  flex-grow: 1;
`;

const SocialSignInGroup = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
`;

export default connect((state, ownProps) => ({}), ActionCreator, null, {
  forwardRef: true,
})(LoginModal);
